import PropTypes from "prop-types";
import React from "react";
// @mui
import { Box, Typography, Link } from "@mui/material";
//
import Breadcrumbs from "./Breadcrumbs";

// ----------------------------------------------------------------------

HeaderBreadcrumbs.propTypes = {
  links: PropTypes.array,
  action: PropTypes.node,
  heading: PropTypes.string.isRequired,
  moreLink: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
  sx: PropTypes.object,
};

export default function HeaderBreadcrumbs({
  links,
  action,
  heading,
  moreLink = "" || [],
  sx,
  ...other
}) {
  return (
    <Box sx={{ mb: 5, ...sx }}>
      <Box sx={{ display: "flex", alignItems: "center" }}>
        <Box sx={{ flexGrow: 1 }}>
          <Typography variant="h4" gutterBottom>
            {heading}
          </Typography>
          <Breadcrumbs key={heading} links={links} {...other} />
        </Box>

        {/* Ensure action is rendered with keys */}
        {action && (
          <Box sx={{ flexShrink: 0 }}>
            {Array.isArray(action)
              ? action.map((item, index) => (
                  <React.Fragment key={index}>{item}</React.Fragment>
                ))
              : action}
          </Box>
        )}
      </Box>

      <Box sx={{ mt: 2 }}>
        {typeof moreLink === "string" ? (
          <Link href={moreLink} target="_blank" rel="noopener" variant="body2">
            {moreLink}
          </Link>
        ) : (
          moreLink.map((href, idx) => (
            <Link
              noWrap
              key={`${href}-${idx}`} // Combine href with index for uniqueness
              href={href}
              variant="body2"
              target="_blank"
              rel="noopener"
              sx={{ display: "table" }}
            >
              {href}
            </Link>
          ))
        )}
      </Box>
    </Box>
  );
}
